module.exports = __webpack_public_path__ + "static/media/transparent-color.bb666d72.svg";